import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_PAGE_CALLS } from 'pages/RouletteGame/roulette.constants'
import { getMyBetsRoulette, placedBetRouletteGame } from './rouletteGame.thunk'
import { getWinningBetTypes } from './game-helpers/index'
import { BET_RESULT } from 'utils/constants/index'
import { plus, minus } from 'number-precision'

const initialState = {
  placedBetData: null,
  betLock: false,
  betLoading: false,
  myBetsData: {
    count: 0,
    rows: []
  },
  betWinAmt: null,
  myBetsLoading: false,
  showWin: false,
  recentWinning: [],
  winTypesContent: null,
  liveStats: {
    totalProfit: 0,
    totalWagered: 0,
    totalWins: 0,
    totalLost: 0
  }
}

const {
  actions: {
    setBetLock,
    setRouletteRoundEnd,
    setBetWinAmt,
    appendMyBetsRoulette,
    setLiveStats
  },
  reducer
} = createSlice({
  name: 'rouletteGame',
  initialState,
  reducers: {
    setLiveStats: (state, action) => {
      const statistics = action.payload?.statistics
      if (!statistics) return state
      return {
        ...state,
        liveStats: { ...statistics }
      }
    },
    setBetLock: (state, action) => {
      return {
        ...state,
        betLock: false
      }
    },
    setRouletteRoundEnd: (state, action) => {
      return {
        ...state,
        showWin: true,
        betLock: false,
        recentWinning: [state.placedBetData, ...state.recentWinning].slice(0, 4)
      }
    },
    setBetWinAmt: (state, action) => ({
      ...state,
      betWinAmt: action.payload || null
    }),
    appendMyBetsRoulette: (state) => {
      const { nextServerSeedHash, ...data } = state.placedBetData || {}
      if (!nextServerSeedHash) return state

      const myBetsDataRows = [data, ...state.myBetsData?.rows]
      if (myBetsDataRows.length > DEFAULT_PAGE_CALLS) myBetsDataRows.pop()

      return {
        ...state,
        myBetsData: {
          count: state.myBetsData.count + 1,
          rows: myBetsDataRows
        },
        liveStats: {
          totalProfit: plus(state.liveStats.totalProfit, minus(data.winningAmount ?? 0, data.betAmount ?? 0)),
          totalWagered: plus(state.liveStats.totalWagered, data.betAmount ?? 0),
          totalWins: plus(state.liveStats.totalWins, data.result === BET_RESULT.WON ? 1 : 0),
          totalLost: plus(state.liveStats.totalLost, data.result === BET_RESULT.LOST ? 1 : 0)
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placedBetRouletteGame.pending, (state, action) => {
        return {
          ...state,
          showWin: false,
          betLock: true,
          betLoading: true,
          winTypesContent: null
        }
      })
      .addCase(placedBetRouletteGame.fulfilled, (state, action) => {
        const { winningNumber } = action.payload || { winningNumber: 0 }

        const winTypesContent = getWinningBetTypes(winningNumber)

        return {
          ...state,
          winTypesContent,
          placedBetData: action.payload,
          betLoading: false
        }
      })
      .addCase(placedBetRouletteGame.rejected, (state, action) => {
        return {
          ...state,
          betLock: false,
          betLoading: false
        }
      })
      .addCase(getMyBetsRoulette.pending, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: true

        }
      })
      .addCase(getMyBetsRoulette.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false

        }
      })
      .addCase(getMyBetsRoulette.rejected, (state, action) => {
        return {
          ...state,
          myBetsLoading: false

        }
      })
  }
})

export {
  setBetLock,
  setBetWinAmt,
  setRouletteRoundEnd,
  appendMyBetsRoulette,
  setLiveStats
}

export default reducer
